import React from "react";
import "./index.less";

const AGPrimoCalculator = () => {

    return (
        <div>
            Home page
        </div>
    );
};

export default AGPrimoCalculator;